var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.734375,
    y: 1.01953,
    width: 21.3974,
    height: 21.3974,
    rx: 3.56624,
    fill: "#243677",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.556063,
    y: 0.841219,
    width: 21.7541,
    height: 21.7541,
    rx: 3.74455,
    stroke: "#243677",
    strokeOpacity: 0.16,
    strokeWidth: 0.356624
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5202_2070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15833 6.98577C6.38237 8.01312 5.1875 9.9333 5.1875 12.1326C5.1875 15.414 7.84768 18.0742 11.1292 18.0742C14.4107 18.0742 17.0708 15.414 17.0708 12.1326C17.0708 9.9333 15.876 8.01312 14.1 6.98577M13.5058 12.1325L11.1292 14.5092M11.1292 14.5092L8.7525 12.1325M11.1292 14.5092V6.19084",
    stroke: "#243677",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5202_2070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.26,
    height: 14.26,
    fill: "white",
    transform: "matrix(1 0 0 -1 4 19.2617)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.5747befa81c1127e928bd5a4e5672f42.svg";
export { ForwardRef as ReactComponent };